import Vue from "vue";
import Cleave from "cleave.js";

Vue.directive("cleave", {
  name: "cleave",
  bind(el, binding) {
    el._vCleave = new Cleave(el, binding.value);
  },
  unbind(el) {
    el._vCleave.destroy();
  }
});
